// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar-module__avatar__qvMLh","regular":"Avatar-module__regular__dheZE","bright":"Avatar-module__bright__3BMGs"};